import { useState } from 'react'
import { useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { useFolders, useCreateFolder } from 'api/hooks/use-folders'
import { useUpdateReport } from 'api/hooks/use-report-builder'
// Relative: `dashboard` is aliased, but this file lives outside it and imports its siblings the
// same way `report-actions-menu` does.
import MoveToFolderModal from '../dashboard/folders/move-to-folder-modal'

// Moves a report into a folder (or out to the top level) by updating its folder_id. Reports move via
// the standard update endpoint — no move_item involved. The folder browser is the shared one the
// index uses for views and samples.
function MoveReportToFolderModal({ report, show, setShow, onMoved }) {
  const queryClient = useQueryClient()
  const { data: foldersData } = useFolders({ options: { enabled: show } })
  const folders = foldersData?.data || foldersData || []
  const [saving, setSaving] = useState(false)

  const { mutateAsync: updateReport } = useUpdateReport({ options: {} })
  const { mutateAsync: createFolder } = useCreateFolder({ options: {} })

  const handleMove = async (folderId) => {
    setSaving(true)
    try {
      await updateReport({ id: report.id, folder_id: folderId })
      toast.success('Report moved')
      onMoved?.()
      setShow(false)
    } catch {
      toast.error('Could not move the report')
    } finally {
      setSaving(false)
    }
  }

  const handleCreateFolder = async (params) => {
    try {
      const folder = await createFolder(params)
      await queryClient.invalidateQueries('folders')
      return folder
    } catch {
      toast.error('Could not create the folder')
      return null
    }
  }

  return (
    <MoveToFolderModal
      show={show}
      onHide={() => setShow(false)}
      itemName={report.name}
      currentFolderId={report.folder_id}
      folders={folders}
      onMove={handleMove}
      isMoving={saving}
      onCreateFolder={handleCreateFolder}
    />
  )
}

export default MoveReportToFolderModal
